import { useQuery } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";
import usePersistentLogin from "../hooks/usePersistentLogin";


export default function useGetAPIDevelopers() {
    const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL;
    const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY;
    const {providerData, isAuthenticated, logout} = useAuth();
    const { tokenLastRefreshed } = usePersistentLogin();
    const token = providerData?.accessToken || providerData?.idToken;

    return useQuery({
      retry: 5,
      enabled: !!tokenLastRefreshed && !!token && isAuthenticated,
      queryKey: ['GET', `${apiAccessUrl}/apidevelopers`],
      queryFn: async () => {
        const response = await fetch(`${apiAccessUrl}/apidevelopers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            "Authorization": `Bearer ${token}`,
            "X-NBLY-Tenant-Code": '',
            "X-NBLY-Portal-Type": '',
            'Ocp-Apim-Subscription-Key': subscriptionKey,
          },
        });

        // Auto logout on token expiration
        if (response.status === 401) {
          logout();
          return null; // Prevents follow-up processing
        }
  
        if (!response.ok) {
          throw new Error('Failed to fetch API developer by email');
        }
  
        return response.json();
      },
    });
  }